import { IServices } from "@netent/origin";
import { IWinState } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const winState: FeatureStateCreator<IWinState> = (
  services: IServices
): IWinState => ({
  valueInCoins: services.win.getWinCoins(),
  valueInCash: services.win.getWinCash(),
  denomination: services.bet.getDenomination()
});
